function AccountSettings () {
	return (
		<span>Account Settings - Coming Soon!</span>
	);
}

export default AccountSettings;